import React, { Component } from "react";
import GraphImg from "graphcms-image";
import styled, { keyframes } from "styled-components";
import baseStyles from "../../styles/baseStyles";

const LogoSlide = ({ image, alt }) => {
  return (
    <GraphImg
      withWebp
      image={image}
      blurryPlaceholder={false}
      max-width={160}
      alt={alt}
      style={{
        flex: 1,
        heigth: "100%",
        width: 160,
        margin: "0 5rem"
      }}
    />
  );
};

const Container = styled.div`
  position: relative;
  max-width: 64rem;
  width: 100%;
  height: 16rem;
  padding: 3rem 0;
  margin: 2rem auto;
  align-items: center;

  @media screen and (max-width: 64em) {
  }
`;

const moveSlideshow = width => keyframes`
  100% { 
    transform: translateX(-${width}px);  
  }
`;

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  min-width: 100%;
  height: 5rem;
  animation: ${props => moveSlideshow(props.length * 320)} 10s linear infinite;
`;

const Title = styled.h2`
  text-transform: uppercase;
  font-family: Poppins;
  letter-spacing: 0.1em;
  font-size: 2.25rem;
  margin-bottom: 1rem;
`;

const TitleDark = Title.extend`
  color: ${baseStyles.color.darkGray};
  text-align: center;
`;

export class PartnersBar extends Component {
  render() {
    return (
      <Container>
        <TitleDark>Our Partners</TitleDark>
        <Wrapper length={this.props.partners.length}>
          {this.props.partners.map(({ node }) => {
            return (
              <a key={`loop1-${node.id}`} href={node.link} target="__blank">
                <LogoSlide image={node.logo} alt={node.name} />
              </a>
            );
          })}
          {this.props.partners.map(({ node }) => {
            return (
              <a key={`loop2-${node.id}`} href={node.link} target="__blank">
                <LogoSlide image={node.logo} alt={node.name} />
              </a>
            );
          })}
        </Wrapper>
      </Container>
    );
  }
}

export default PartnersBar;



// WEBPACK FOOTER //
// ./src/components/PartnersBar/index.js